/**
 * E-Voucher deposit tab copy for locales that use `panelDwiOverrides` (not the
 * full `panelDepositWithdrawInbox` es/de bundles).
 */
const voucherFr = {
  'user.deposit.voucher.redeemTitle': 'Échanger un E-voucher',
  'user.deposit.voucher.generateTitle': 'Générer un E-voucher',
  'user.deposit.voucher.code': 'Code du bon',
  'user.deposit.voucher.pin': 'PIN à 4 chiffres',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0,00',
  'user.deposit.voucher.redeem': 'Échanger le bon',
  'user.deposit.voucher.redeeming': 'Échange en cours…',
  'user.deposit.voucher.convertHint': 'Convertissez votre solde en un bon transférable',
  'user.deposit.voucher.amountLabel': 'Montant à convertir',
  'user.deposit.voucher.availableBalance': 'Solde disponible : {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'Solde disponible : chargement…',
  'user.deposit.voucher.generate': 'Générer le bon',
  'user.deposit.voucher.generating': 'Génération…',
  'user.deposit.voucher.yourVoucher': 'Votre E-voucher',
  'user.deposit.voucher.copyAll': 'Copier tous les détails',
  'user.deposit.voucher.warnOnce':
    'Ce bon ne peut être utilisé qu’une seule fois. Conservez-le en lieu sûr.',
  'user.deposit.voucher.clipboard': 'Code : {{code}}\nPIN : {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'Saisissez un montant valide.',
  'user.deposit.voucher.toastCodePin': 'Saisissez un code à 12 caractères et un PIN à 4 chiffres.',
  'user.deposit.voucher.toastGenFail': 'Échec de la génération du bon.',
  'user.deposit.voucher.toastRedeemFail': 'Échec de l’échange du bon.',
  'user.deposit.voucher.toastGenOk': 'Bon généré avec succès.',
  'user.deposit.voucher.toastCopied': 'Détails du bon copiés.',
  'user.deposit.voucher.toastRedeemed': 'Bon échangé. {{amount}} ajoutés.',
};

const voucherAr = {
  'user.deposit.voucher.redeemTitle': 'استرداد القسيمة الإلكترونية',
  'user.deposit.voucher.generateTitle': 'إنشاء قسيمة إلكترونية',
  'user.deposit.voucher.code': 'رمز القسيمة',
  'user.deposit.voucher.pin': 'رمز PIN مكون من 4 أرقام',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': 'استرداد القسيمة',
  'user.deposit.voucher.redeeming': 'جاري الاسترداد…',
  'user.deposit.voucher.convertHint': 'حوّل رصيدك إلى قسيمة قابلة للتحويل',
  'user.deposit.voucher.amountLabel': 'المبلغ المراد تحويله',
  'user.deposit.voucher.availableBalance': 'الرصيد المتاح: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'الرصيد المتاح: جاري التحميل…',
  'user.deposit.voucher.generate': 'إنشاء قسيمة',
  'user.deposit.voucher.generating': 'جاري الإنشاء…',
  'user.deposit.voucher.yourVoucher': 'قسيمتك الإلكترونية',
  'user.deposit.voucher.copyAll': 'نسخ كل التفاصيل',
  'user.deposit.voucher.warnOnce':
    'يمكن استرداد هذه القسيمة مرة واحدة فقط. احتفظ بها في مكان آمن.',
  'user.deposit.voucher.clipboard': 'الرمز: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'أدخل مبلغاً صالحاً.',
  'user.deposit.voucher.toastCodePin': 'أدخل رمزاً مكوناً من 12 حرفاً وPIN مكوناً من 4 أرقام.',
  'user.deposit.voucher.toastGenFail': 'فشل إنشاء القسيمة.',
  'user.deposit.voucher.toastRedeemFail': 'فشل استرداد القسيمة.',
  'user.deposit.voucher.toastGenOk': 'تم إنشاء القسيمة بنجاح.',
  'user.deposit.voucher.toastCopied': 'تم نسخ تفاصيل القسيمة.',
  'user.deposit.voucher.toastRedeemed': 'تم استرداد القسيمة. {{amount}} مضافة.',
};

const voucherJa = {
  'user.deposit.voucher.redeemTitle': 'Eバウチャーを利用',
  'user.deposit.voucher.generateTitle': 'Eバウチャーを発行',
  'user.deposit.voucher.code': 'バウチャーコード',
  'user.deposit.voucher.pin': '4桁のPIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': 'バウチャーを利用',
  'user.deposit.voucher.redeeming': '利用中…',
  'user.deposit.voucher.convertHint': '残高を譲渡可能なバウチャーに変換します',
  'user.deposit.voucher.amountLabel': '変換する金額',
  'user.deposit.voucher.availableBalance': '利用可能残高: {{amount}}',
  'user.deposit.voucher.availableLineLoading': '利用可能残高: 読み込み中…',
  'user.deposit.voucher.generate': 'バウチャーを発行',
  'user.deposit.voucher.generating': '発行中…',
  'user.deposit.voucher.yourVoucher': 'あなたのEバウチャー',
  'user.deposit.voucher.copyAll': '詳細をすべてコピー',
  'user.deposit.voucher.warnOnce':
    'このバウチャーは1回のみ利用できます。安全に保管してください。',
  'user.deposit.voucher.clipboard': 'コード: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': '有効な金額を入力してください。',
  'user.deposit.voucher.toastCodePin': '12文字のコードと4桁のPINを入力してください。',
  'user.deposit.voucher.toastGenFail': 'バウチャーの発行に失敗しました。',
  'user.deposit.voucher.toastRedeemFail': 'バウチャーの利用に失敗しました。',
  'user.deposit.voucher.toastGenOk': 'バウチャーを発行しました。',
  'user.deposit.voucher.toastCopied': 'バウチャー情報をコピーしました。',
  'user.deposit.voucher.toastRedeemed': 'バウチャーを利用しました。{{amount}} が加算されました。',
};

const voucherKo = {
  'user.deposit.voucher.redeemTitle': 'E-바우처 사용',
  'user.deposit.voucher.generateTitle': 'E-바우처 발급',
  'user.deposit.voucher.code': '바우처 코드',
  'user.deposit.voucher.pin': '4자리 PIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': '바우처 사용',
  'user.deposit.voucher.redeeming': '사용 중…',
  'user.deposit.voucher.convertHint': '잔액을 양도 가능한 바우처로 전환합니다',
  'user.deposit.voucher.amountLabel': '전환할 금액',
  'user.deposit.voucher.availableBalance': '사용 가능 잔액: {{amount}}',
  'user.deposit.voucher.availableLineLoading': '사용 가능 잔액: 불러오는 중…',
  'user.deposit.voucher.generate': '바우처 발급',
  'user.deposit.voucher.generating': '발급 중…',
  'user.deposit.voucher.yourVoucher': '내 E-바우처',
  'user.deposit.voucher.copyAll': '전체 정보 복사',
  'user.deposit.voucher.warnOnce':
    '이 바우처는 한 번만 사용할 수 있습니다. 안전하게 보관하세요.',
  'user.deposit.voucher.clipboard': '코드: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': '유효한 금액을 입력하세요.',
  'user.deposit.voucher.toastCodePin': '12자 코드와 4자리 PIN을 입력하세요.',
  'user.deposit.voucher.toastGenFail': '바우처 발급에 실패했습니다.',
  'user.deposit.voucher.toastRedeemFail': '바우처 사용에 실패했습니다.',
  'user.deposit.voucher.toastGenOk': '바우처가 발급되었습니다.',
  'user.deposit.voucher.toastCopied': '바우처 정보가 복사되었습니다.',
  'user.deposit.voucher.toastRedeemed': '바우처를 사용했습니다. {{amount}}가 추가되었습니다.',
};

const voucherZhCN = {
  'user.deposit.voucher.redeemTitle': '兑换电子券',
  'user.deposit.voucher.generateTitle': '生成电子券',
  'user.deposit.voucher.code': '券码',
  'user.deposit.voucher.pin': '4 位 PIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': '兑换',
  'user.deposit.voucher.redeeming': '兑换中…',
  'user.deposit.voucher.convertHint': '将余额转换为可转让的电子券',
  'user.deposit.voucher.amountLabel': '转换金额',
  'user.deposit.voucher.availableBalance': '可用余额：{{amount}}',
  'user.deposit.voucher.availableLineLoading': '可用余额：加载中…',
  'user.deposit.voucher.generate': '生成电子券',
  'user.deposit.voucher.generating': '生成中…',
  'user.deposit.voucher.yourVoucher': '您的电子券',
  'user.deposit.voucher.copyAll': '复制全部信息',
  'user.deposit.voucher.warnOnce': '此电子券仅可兑换一次，请妥善保管。',
  'user.deposit.voucher.clipboard': '券码：{{code}}\nPIN：{{pin}}',
  'user.deposit.voucher.toastValidAmount': '请输入有效金额。',
  'user.deposit.voucher.toastCodePin': '请输入 12 位券码和 4 位 PIN。',
  'user.deposit.voucher.toastGenFail': '生成电子券失败。',
  'user.deposit.voucher.toastRedeemFail': '兑换失败。',
  'user.deposit.voucher.toastGenOk': '电子券已生成。',
  'user.deposit.voucher.toastCopied': '已复制电子券信息。',
  'user.deposit.voucher.toastRedeemed': '兑换成功。已增加 {{amount}}。',
};

const voucherPt = {
  'user.deposit.voucher.redeemTitle': 'Resgatar E-voucher',
  'user.deposit.voucher.generateTitle': 'Gerar E-voucher',
  'user.deposit.voucher.code': 'Código do voucher',
  'user.deposit.voucher.pin': 'PIN de 4 dígitos',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0,00',
  'user.deposit.voucher.redeem': 'Resgatar voucher',
  'user.deposit.voucher.redeeming': 'A resgatar…',
  'user.deposit.voucher.convertHint': 'Converta o seu saldo num voucher transferível',
  'user.deposit.voucher.amountLabel': 'Montante a converter',
  'user.deposit.voucher.availableBalance': 'Saldo disponível: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'Saldo disponível: a carregar…',
  'user.deposit.voucher.generate': 'Gerar voucher',
  'user.deposit.voucher.generating': 'A gerar…',
  'user.deposit.voucher.yourVoucher': 'O seu E-voucher',
  'user.deposit.voucher.copyAll': 'Copiar todos os detalhes',
  'user.deposit.voucher.warnOnce':
    'Este voucher só pode ser resgatado uma vez. Guarde-o em segurança.',
  'user.deposit.voucher.clipboard': 'Código: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'Introduza um montante válido.',
  'user.deposit.voucher.toastCodePin': 'Introduza um código de 12 caracteres e um PIN de 4 dígitos.',
  'user.deposit.voucher.toastGenFail': 'Falha ao gerar o voucher.',
  'user.deposit.voucher.toastRedeemFail': 'Falha ao resgatar o voucher.',
  'user.deposit.voucher.toastGenOk': 'Voucher gerado com sucesso.',
  'user.deposit.voucher.toastCopied': 'Detalhes do voucher copiados.',
  'user.deposit.voucher.toastRedeemed': 'Voucher resgatado. {{amount}} adicionados.',
};

const voucherIt = {
  'user.deposit.voucher.redeemTitle': 'Riscatta E-voucher',
  'user.deposit.voucher.generateTitle': 'Genera E-voucher',
  'user.deposit.voucher.code': 'Codice voucher',
  'user.deposit.voucher.pin': 'PIN a 4 cifre',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0,00',
  'user.deposit.voucher.redeem': 'Riscatta voucher',
  'user.deposit.voucher.redeeming': 'Riscatto in corso…',
  'user.deposit.voucher.convertHint': 'Converti il saldo in un voucher trasferibile',
  'user.deposit.voucher.amountLabel': 'Importo da convertire',
  'user.deposit.voucher.availableBalance': 'Saldo disponibile: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'Saldo disponibile: caricamento…',
  'user.deposit.voucher.generate': 'Genera voucher',
  'user.deposit.voucher.generating': 'Generazione…',
  'user.deposit.voucher.yourVoucher': 'Il tuo E-voucher',
  'user.deposit.voucher.copyAll': 'Copia tutti i dettagli',
  'user.deposit.voucher.warnOnce':
    'Questo voucher può essere riscattato una sola volta. Conservalo al sicuro.',
  'user.deposit.voucher.clipboard': 'Codice: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'Inserisci un importo valido.',
  'user.deposit.voucher.toastCodePin': 'Inserisci un codice di 12 caratteri e un PIN a 4 cifre.',
  'user.deposit.voucher.toastGenFail': 'Impossibile generare il voucher.',
  'user.deposit.voucher.toastRedeemFail': 'Impossibile riscattare il voucher.',
  'user.deposit.voucher.toastGenOk': 'Voucher generato con successo.',
  'user.deposit.voucher.toastCopied': 'Dettagli del voucher copiati.',
  'user.deposit.voucher.toastRedeemed': 'Voucher riscattato. {{amount}} aggiunti.',
};

const voucherRu = {
  'user.deposit.voucher.redeemTitle': 'Активировать E-ваучер',
  'user.deposit.voucher.generateTitle': 'Создать E-ваучер',
  'user.deposit.voucher.code': 'Код ваучера',
  'user.deposit.voucher.pin': '4-значный PIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0,00',
  'user.deposit.voucher.redeem': 'Активировать ваучер',
  'user.deposit.voucher.redeeming': 'Активация…',
  'user.deposit.voucher.convertHint': 'Превратите баланс в передаваемый ваучер',
  'user.deposit.voucher.amountLabel': 'Сумма для конвертации',
  'user.deposit.voucher.availableBalance': 'Доступный баланс: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'Доступный баланс: загрузка…',
  'user.deposit.voucher.generate': 'Создать ваучер',
  'user.deposit.voucher.generating': 'Создание…',
  'user.deposit.voucher.yourVoucher': 'Ваш E-ваучер',
  'user.deposit.voucher.copyAll': 'Скопировать все данные',
  'user.deposit.voucher.warnOnce':
    'Ваучер можно активировать только один раз. Храните его в безопасности.',
  'user.deposit.voucher.clipboard': 'Код: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'Введите корректную сумму.',
  'user.deposit.voucher.toastCodePin': 'Введите код из 12 символов и 4-значный PIN.',
  'user.deposit.voucher.toastGenFail': 'Не удалось создать ваучер.',
  'user.deposit.voucher.toastRedeemFail': 'Не удалось активировать ваучер.',
  'user.deposit.voucher.toastGenOk': 'Ваучер успешно создан.',
  'user.deposit.voucher.toastCopied': 'Данные ваучера скопированы.',
  'user.deposit.voucher.toastRedeemed': 'Ваучер активирован. Добавлено {{amount}}.',
};

const voucherBn = {
  'user.deposit.voucher.redeemTitle': 'ই-ভাউচার রিডিম',
  'user.deposit.voucher.generateTitle': 'ই-ভাউচার তৈরি',
  'user.deposit.voucher.code': 'ভাউচার কোড',
  'user.deposit.voucher.pin': '৪ সংখ্যার PIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': 'ভাউচার রিডিম',
  'user.deposit.voucher.redeeming': 'রিডিম হচ্ছে…',
  'user.deposit.voucher.convertHint': 'আপনার ব্যালেন্স হস্তান্তরযোগ্য ভাউচারে রূপান্তর করুন',
  'user.deposit.voucher.amountLabel': 'রূপান্তরের পরিমাণ',
  'user.deposit.voucher.availableBalance': 'উপলব্ধ ব্যালেন্স: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'উপলব্ধ ব্যালেন্স: লোড হচ্ছে…',
  'user.deposit.voucher.generate': 'ভাউচার তৈরি',
  'user.deposit.voucher.generating': 'তৈরি হচ্ছে…',
  'user.deposit.voucher.yourVoucher': 'আপনার ই-ভাউচার',
  'user.deposit.voucher.copyAll': 'সব বিবরণ কপি করুন',
  'user.deposit.voucher.warnOnce':
    'এই ভাউচার শুধু একবার রিডিম করা যাবে। নিরাপদে রাখুন।',
  'user.deposit.voucher.clipboard': 'কোড: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'বৈধ পরিমাণ লিখুন।',
  'user.deposit.voucher.toastCodePin': '১২ অক্ষরের কোড ও ৪ সংখ্যার PIN লিখুন।',
  'user.deposit.voucher.toastGenFail': 'ভাউচার তৈরি ব্যর্থ।',
  'user.deposit.voucher.toastRedeemFail': 'ভাউচার রিডিম ব্যর্থ।',
  'user.deposit.voucher.toastGenOk': 'ভাউচার সফলভাবে তৈরি হয়েছে।',
  'user.deposit.voucher.toastCopied': 'ভাউচারের বিবরণ কপি হয়েছে।',
  'user.deposit.voucher.toastRedeemed': 'ভাউচার রিডিম। {{amount}} যোগ হয়েছে।',
};

const voucherHi = {
  'user.deposit.voucher.redeemTitle': 'ई-वाउचर रिडीम करें',
  'user.deposit.voucher.generateTitle': 'ई-वाउचर बनाएं',
  'user.deposit.voucher.code': 'वाउचर कोड',
  'user.deposit.voucher.pin': '4 अंकों का PIN',
  'user.deposit.voucher.copyPinLabel': 'PIN',
  'user.deposit.voucher.placeholderCode': 'XXXX-XXXX-XXXX',
  'user.deposit.voucher.placeholderPin': '••••',
  'user.deposit.voucher.placeholderAmount': '0.00',
  'user.deposit.voucher.redeem': 'वाउचर रिडीम करें',
  'user.deposit.voucher.redeeming': 'रिडीम हो रहा है…',
  'user.deposit.voucher.convertHint': 'अपना बैलेंस हस्तांतरणीय वाउचर में बदलें',
  'user.deposit.voucher.amountLabel': 'रूपांतरण राशि',
  'user.deposit.voucher.availableBalance': 'उपलब्ध शेष: {{amount}}',
  'user.deposit.voucher.availableLineLoading': 'उपलब्ध शेष: लोड हो रहा है…',
  'user.deposit.voucher.generate': 'वाउचर बनाएं',
  'user.deposit.voucher.generating': 'बन रहा है…',
  'user.deposit.voucher.yourVoucher': 'आपका ई-वाउचर',
  'user.deposit.voucher.copyAll': 'सभी विवरण कॉपी करें',
  'user.deposit.voucher.warnOnce':
    'यह वाउचर केवल एक बार रिडीम हो सकता है। इसे सुरक्षित रखें।',
  'user.deposit.voucher.clipboard': 'कोड: {{code}}\nPIN: {{pin}}',
  'user.deposit.voucher.toastValidAmount': 'मान्य राशि दर्ज करें।',
  'user.deposit.voucher.toastCodePin': '12 अक्षर का कोड और 4 अंकों का PIN दर्ज करें।',
  'user.deposit.voucher.toastGenFail': 'वाउचर बनाने में विफल।',
  'user.deposit.voucher.toastRedeemFail': 'वाउचर रिडीम करने में विफल।',
  'user.deposit.voucher.toastGenOk': 'वाउचर सफलतापूर्वक बनाया गया।',
  'user.deposit.voucher.toastCopied': 'वाउचर विवरण कॉपी हो गए।',
  'user.deposit.voucher.toastRedeemed': 'वाउचर रिडीम। {{amount}} जोड़े गए।',
};

export const panelDepositVoucherOverrides = {
  fr: voucherFr,
  ar: voucherAr,
  ja: voucherJa,
  ko: voucherKo,
  'zh-CN': voucherZhCN,
  pt: voucherPt,
  it: voucherIt,
  ru: voucherRu,
  bn: voucherBn,
  hi: voucherHi,
};
